import { render, staticRenderFns } from "./Different.vue?vue&type=template&id=b2e690c2&scoped=true&"
import script from "./Different.vue?vue&type=script&lang=js&"
export * from "./Different.vue?vue&type=script&lang=js&"
import style0 from "./Different.vue?vue&type=style&index=0&id=b2e690c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e690c2",
  null
  
)

component.options.__file = "Different.vue"
export default component.exports